import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function EmptyDisplayQuality({ isChanging, onClick }) {
  return (
    <button
      className={classnames('button--link icon display-quality display-quality--empty', isChanging && 'display-quality--is-changing')}
      style={{ width: 40, height: 40 }}
      type="button"
      onClick={onClick}
    />
  );
}

EmptyDisplayQuality.displayName = 'EmptyDisplayQuality';

EmptyDisplayQuality.propTypes = {
  isChanging: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};